export var ASSIGNMENT_CONFIGURATION_REPOSITORY = 'ASSIGNMENT_CONFIGURATION_REPOSITORY';